module.exports = __webpack_public_path__ + "7497770bbf845b349ae187d386b2be7d.pdf";